import requirementsData from "../data/requirements.json";

import { ProductRequirementTable } from "./ProductRequirementTable";
import type { ProductRequirementData } from "./productTableTypes";

export const ProductTable = () => {
  const requirements = requirementsData.requirements as ProductRequirementData[];

  return (
    <>
      {requirements.map((requirement) => (
        <ProductRequirementTable
          key={`${requirement.plan}_produtos`}
          requirement={requirement}
        />
      ))}
    </>
  );
};